import(/* webpackMode: "eager" */ "/home/ubuntu/download/6988d61b187bbe0013f2067c/website_project/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988d61b187bbe0013f2067c/website_project/src/app/services/components/CIDIFLYAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988d61b187bbe0013f2067c/website_project/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6988d61b187bbe0013f2067c/website_project/src/components/ui/AppIcon.tsx");
